module.exports = __webpack_public_path__ + "static/img/msh5.74f8fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/msh5.png
// module id = Szls
// module chunks = 0